"use client";
import Link from "next/link";
import { ArrowRight, Layers, Trophy, Cpu, BarChart3, Server, Shield } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { usps as data } from "@/lib/data/engine-autonomous-operations";

const uspIcons = [Layers, Trophy, Cpu, BarChart3, Server, Shield] as const;
const accents = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-emerald)", "var(--color-amber)", "var(--color-denim)"] as const;

export function Usps() {
  return (
    <Section id="usps" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-violet)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.usps.map((u, i) => {
            const Icon = uspIcons[i % uspIcons.length]!;
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={u.title} delay={i * 80}>
                <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}>
                  <div className="flex items-center justify-between mb-3">
                    <span
                      className="grid place-items-center h-10 w-10 rounded-lg"
                      style={{
                        background: `color-mix(in oklch, ${accent} 18%, transparent)`,
                        boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                      }}
                    >
                      <Icon className="h-4 w-4" style={{ color: accent }} />
                    </span>
                    <span className="eyebrow-tiny font-bold" style={{ color: accent }}>0{i + 1}</span>
                  </div>
                  <h3 className="text-lg">{u.title}</h3>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{u.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-10">
            <Link href={data.cta.href} className="btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm">
              {data.cta.label} <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
